import React, { useState } from "react";
import { useSelector } from "react-redux";
import { socket } from "../../App";
import axios from "../Hooks/axios";
import styles from "./Suggestion.module.scss";
import { MdPersonAddAlt } from "react-icons/md";
import { toast } from "react-toastify";
import Avatar from "../Avatar/Avatar";

const UserBox = ({ data }) => {
	const { user, userId } = useSelector((s) => s.auth);
	const [follow, setFollow] = useState("Follow");

	const handleFollow = () => {
		let sd = {
			notification_from: userId,
			notification_to: data?._id,
			notification: {},
			title: "Follow",
			message: `${user?.username} started following you`,
		};

		const raw = { following: data?._id };

		axios
			.post(`/auth/follow`, raw)
			.then(({ data: resData }) => {
				console.log(resData);
				if (resData.message === "follow") {
					setFollow("Following");
					toast.success(`You started following ${data?.username}`);
					socket.emit("notification", sd);
				}
				if (resData.message === "unfollow") {
					setFollow("Follow");
					toast.info(`You unfollowed ${data?.username}`);
				}
			})
			.catch((e) => {
				console.log(e);
				toast.error("Something went wrong");
			});
	};

	return (
		<div className={styles.BoxWrapperMain} onDragStart={(e) => e.preventDefault()}>
			<div className={styles.BoxWrapper}>
				{/* <div className={styles.Top}>
					<img src={data?.personaThumbnail} alt="" />
				</div> */}

				<div className={styles.Bottom}>
					<div className={styles.TopSection}>
						<div className={styles.ImageWrapper}>
							<Avatar 
								src={data?.ProfilePic} 
								name={data?.username} 
								className={styles.avatarImg}
								style={{ fontSize: "2rem" }}
							/>
						</div>

						<div className={styles.TextWrapper}>
							<h2>{data?.username?.length > 15 ? data?.username?.substring(0, 15) + "..." : data?.username}</h2>
							<p>
								@
								{(data?.GetstatedName || data?.username?.toLowerCase()?.replace(/\s/g, ''))?.length > 25
									? (data?.GetstatedName || data?.username?.toLowerCase()?.replace(/\s/g, ''))?.substring(0, 25) + "..."
									: (data?.GetstatedName || data?.username?.toLowerCase()?.replace(/\s/g, '')) || "user"}
							</p>
						</div>
					</div>

					<button className={styles.Button} onClick={handleFollow}>
						{/* {follow} */}
						<MdPersonAddAlt />
					</button>
				</div>
			</div>
		</div>
	);
};

export default UserBox;


